import type React from "react";

import {usePanningControls} from "~/hooks/usePanningControls";

import useZoomControls from "../../../hooks/useZoomControls";
import SelectionControls from "../../../three/selection/controls/SelectionControls";

const EditLevelR3F: React.FC = () => {
  useZoomControls();
  usePanningControls();
  return (
    <>
      <SelectionControls />
    </>
  );
};

export default EditLevelR3F;
